<div>
    <img id="mobileLogo" src="assets/images/menu.png" alt="logo" (click)="showNav()"/>
</div> 

<header>
  <nav class="headerlinks">
    <div class="X" (click)="hideNav()">X</div>
    <a routerLink="/welcome" routerLinkActive="active" (click)="onLinkClick()">Startseite</a>
    <a routerLink="/ancestors" routerLinkActive="active" (click)="onLinkClick()">Stammfolge</a>
    @if (this.isAdmin) {
    <a routerLink="/admin-ancestors" routerLinkActive="active" (click)="onLinkClick()">Stammfolge bearbeiten</a>}
    <a routerLink="/discussions" routerLinkActive="active" (click)="onLinkClick()">Diskussionen zur Stammfolge</a>
    <a routerLink="/faminfos" routerLinkActive="active" (click)="onLinkClick()">Familieninfos</a>
    <a routerLink="/recipes" routerLinkActive="active" (click)="onLinkClick()">Familienrezepte</a>
    <a routerLink="/account" routerLinkActive="active" (click)="onLinkClick()">Konto</a>
    <a routerLink="/infos" routerLinkActive="active" (click)="onLinkClick()">Diskussion zur Webseite</a>

    <div id="divider"></div>
    <button (click)="logout()">Ausloggen</button> 
  </nav>

</header>
